<template>
  <div>
    <app-cells><h1 class="title">List of orders</h1></app-cells>
    <app-tabs :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'ProductStorageOrdersLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'product-storage-orders-active', label: 'Active' },
        { name: 'product-storage-orders-completed', label: 'Completed' },
      ]
    }
  },
}
</script>
